import Loader from '@/components/Loader';
import React, { createContext, useState, useContext, ReactNode } from 'react';

interface LoaderContextType {
  showLoader: () => void;
  hideLoader: () => void;
  isLoading: boolean; // Add isLoading to the context type
}

const LoaderContext = createContext<LoaderContextType | undefined>(undefined);

export const LoaderProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [open, setOpen] = useState(false);

  const showLoader = () => setOpen(true);
  const hideLoader = () => setOpen(false);

  return (
    <LoaderContext.Provider value={{ showLoader, hideLoader, isLoading: open }}>
      {children}
      <Loader open={open} />
    </LoaderContext.Provider>
  );
};

export const useLoader = () => {
  const context = useContext(LoaderContext);
  if (context === undefined) {
    throw new Error('useLoader must be used within a LoaderProvider');
  }
  return context;
};
